export const getSystemPopupTimeKey = (id: string | number) => `systemPopup${id}Time`;

export const checkExpired = (key: string) => Number(localStorage.getItem(key)) < new Date().getTime();

export const versionKey = "prVersionCode";

export const penSettingKey = "coReportPenSetting";

export const purchaseGoodsKey = "purchaseGoodsId";